import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/finances/container_outcomes/show_process/${agro_exporter_id}/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  },
  fetchContainer(agro_exporter_id, container_id) {
    return RequesterV1.get(
      `agro_exporter/finances/container_outcomes/show_container/${agro_exporter_id}/fetch_container/${container_id}`
    );
  },
  fetchOrgInvoices(agro_exporter_id, org_invoice_id) {
    return RequesterV1.get(
      `agro_exporter/finances/container_outcomes/show_container/${agro_exporter_id}/fetch_org_invoices/${org_invoice_id}`
    );
  }
};
